<template>
	<div class="edit-substance">
		<NavBar v-if="admin" :admin="true" :items="items" />
		<Breadcrumbs v-else :items="items" />
		<v-main :class="admin ? 'ma-12' : 'pa-0'">
			<v-progress-linear indeterminate color="primary" v-if="!loaded"></v-progress-linear>
			<SubstanceForm
				v-if="loaded"
				:product="product"
				:edit="true"
				:language="language"
				:admin="admin"
				:drugInteractions="drugInteractions"
			/>
		</v-main>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NavBar from "@/components/authentication/NavBar.vue";
import SubstanceForm from "@/components/products/SubstanceForm.vue";
import axios from "axios";

export default {
	name: "EditSubstance",
	components: {
		Breadcrumbs,
		NavBar,
		SubstanceForm
	},
	props: {
		language: { default: null }
	},
	data: () => ({
		product: {
			indications_icd: [],
			contraindications_icd: [],
			drugs: []
		},
		drugInteractions: [],
		loaded: false
	}),
	computed: {
		admin() {
			return this.$store.getters.hasRole('admin');
		},
		items() {
			if (this.admin) {
				return [
					{
						text: this.$gettext("Dashboard"),
						disabled: false,
						link: true,
						to: { name: "dashboard" }
					},
					{
						text: this.$gettext("Chinese Materia Medica"),
						disabled: false,
						link: true,
						to: { name: "admin-cmm", params: { admin: true } }
					},
					{
						text: this.product.name,
						disabled: true,
						link: true
					},
					{
						text: this.$gettext("Edit"),
						disabled: true,
						link: true
					}
				];
			} else {
				return [
					{
						text: this.$gettext("Settings"),
						disabled: true,
						link: true,
						to: { name: "settings" }
					},
					{
						text: this.$gettext("Treatments"),
						disabled: false,
						link: true,
						to: { name: "settings", params: { tab: "treatments" } }
					},
					{
						text: this.$gettext("Chinese Materia Medica"),
						disabled: false,
						link: true,
						to: { name: "cmm" }
					},
					{
						name: true,
						text: this.product.name,
						disabled: true,
						link: true
					},
					{
						text: this.$gettext("Edit"),
						disabled: true,
						link: true
					}
				];
			}
		}
	},
	created() {
		const productId = this.$route.params.sid;
		var params = {};
		if (this.language) {
			params = {
				language: this.language
			};
		}
		axios
			.get("/mtc/substances/" + productId + "/edit", {
				params: params
			})
			.then(response => {
				console.log(response.data);
				this.product = response.data.product;
				this.drugInteractions = response.data.medicine_interactions;
				this.loaded = true;
			})
			.catch(error => {
				console.log(error);
			});
	}
};
</script>
